import React from 'react';
import logo from 'images/logo/IE-logo-2.png';

const LumpSumApplicationDoc = ({
  docRef,
  formData = {},
  rateCalculation = {},
  questionnaire = {},
  achPayment = {},
  applicationRefId = '',
  submissionDate = '',
  ipAddress = '',
  signatureImage = ''
}) => {
  const fullName = `${formData.firstName || ''} ${formData.lastName || ''}`.trim() || 'N/A';
  const displayPhone = formData.phone || 'N/A';
  const displayEmail = formData.email || 'N/A';
  const displayZip = formData.zipCode || 'N/A';
  const displayDob = formData.dob || 'N/A';
  const displayAge = formData.age ? `${formData.age} yrs` : 'N/A';
  const displayGender = formData.gender ? (formData.gender === 'male' ? 'Male' : 'Female') : 'N/A';

  const totalBenefit = rateCalculation.coverageAmount ? `$${rateCalculation.coverageAmount.toLocaleString()}` : '$50,000';
  const monthlyRate = rateCalculation.totalMonthlyPremium ? `$${rateCalculation.totalMonthlyPremium.toFixed(2)} / month` : '$0.00 / month';

  const q1Answer = questionnaire.q1_replacing_or_declined ? questionnaire.q1_replacing_or_declined.toUpperCase() : 'NO';
  const q2Answer = questionnaire.q2_cancer_or_tests ? questionnaire.q2_cancer_or_tests.toUpperCase() : 'NO';
  const q3Answer = questionnaire.q3_hiv_aids ? questionnaire.q3_hiv_aids.toUpperCase() : 'NO';

  const routing = achPayment.routingNumber || 'N/A';
  const bankName = achPayment.bankName || 'N/A';
  const fullAcct = achPayment.accountNumber || 'N/A';
  const holderName = achPayment.bankCustomerName || 'N/A';

  return (
    <div
      ref={docRef}
      style={{
        width: '816px',
        minHeight: '1056px',
        backgroundColor: '#ffffff',
        color: '#0f172a',
        fontFamily: 'Helvetica, Arial, sans-serif',
        padding: '36px 40px',
        boxSizing: 'border-box'
      }}
    >
      {/* 1. Header with Logo & Title */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '2px solid #0f172a', paddingBottom: '14px', marginBottom: '20px' }}>
        <div>
          <img src={logo} alt="Insurance Enterprise Logo" style={{ height: '42px', width: 'auto', display: 'block' }} />
          <div style={{ fontSize: '11px', color: '#64748b', marginTop: '4px', fontWeight: 'bold' }}>
            Insurance Enterprise USA • (888) 350-6605
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          <div style={{ fontSize: '16px', fontWeight: 'bold', color: '#0f172a', textTransform: 'uppercase', letterSpacing: '-0.3px' }}>
            Lump Sum Benefits Application
          </div>
          <div style={{ fontSize: '11px', color: '#64748b', marginTop: '3px' }}>
            Ref: <strong style={{ color: '#0f172a' }}>#{applicationRefId || 'LS-APP'}</strong> • {submissionDate || new Date().toLocaleString()}
          </div>
        </div>
      </div>

      {/* 2. Form Labels and Filled Fields */}
      <div style={{ border: '1px solid #cbd5e1', borderRadius: '4px', overflow: 'hidden', marginBottom: '20px' }}>
        <div style={{ backgroundColor: '#f8fafc', borderBottom: '1px solid #cbd5e1', padding: '8px 14px', fontWeight: 'bold', fontSize: '12px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
          Application Details
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px', tableLayout: 'fixed' }}>
          <tbody>
            <tr style={{ borderBottom: '1px solid #f1f5f9' }}>
              <td style={{ width: '25%', padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Applicant Name</td>
              <td style={{ width: '25%', padding: '8px 14px', fontWeight: 'bold', wordBreak: 'break-word' }}>{fullName}</td>
              <td style={{ width: '25%', padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Date of Birth / Age</td>
              <td style={{ width: '25%', padding: '8px 14px', wordBreak: 'break-word' }}>{displayDob} ({displayAge})</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #f1f5f9' }}>
              <td style={{ padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Gender</td>
              <td style={{ padding: '8px 14px', wordBreak: 'break-word' }}>{displayGender}</td>
              <td style={{ padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>ZIP Code</td>
              <td style={{ padding: '8px 14px', wordBreak: 'break-word' }}>{displayZip}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #f1f5f9' }}>
              <td style={{ padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Cell Phone</td>
              <td style={{ padding: '8px 14px', wordBreak: 'break-word' }}>{displayPhone}</td>
              <td style={{ padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Email Address</td>
              <td style={{ padding: '8px 14px', wordBreak: 'break-all' }}>{displayEmail}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #f1f5f9' }}>
              <td style={{ padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Coverage Amount</td>
              <td style={{ padding: '8px 14px', fontWeight: 'bold', color: '#16a34a', fontSize: '12px', wordBreak: 'break-word' }}>{totalBenefit}</td>
              <td style={{ padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Monthly Premium</td>
              <td style={{ padding: '8px 14px', fontWeight: 'bold', fontSize: '12px', wordBreak: 'break-word' }}>{monthlyRate}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #f1f5f9' }}>
              <td style={{ padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Health Q1 (Replacing / Declined)</td>
              <td style={{ padding: '8px 14px', fontWeight: 'bold', wordBreak: 'break-word' }}>{q1Answer} {questionnaire.q1_details ? `(${questionnaire.q1_details})` : ''}</td>
              <td style={{ padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Health Q2 (Cancer / Medical Tests)</td>
              <td style={{ padding: '8px 14px', fontWeight: 'bold', wordBreak: 'break-word' }}>{q2Answer} {questionnaire.q2_details ? `(${questionnaire.q2_details})` : ''}</td>
            </tr>
            <tr style={{ borderBottom: '1px solid #f1f5f9' }}>
              <td style={{ padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Health Q3 (HIV / AIDS)</td>
              <td style={{ padding: '8px 14px', fontWeight: 'bold', wordBreak: 'break-word' }}>{q3Answer} {questionnaire.q3_details ? `(${questionnaire.q3_details})` : ''}</td>
              <td style={{ padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Routing Number</td>
              <td style={{ padding: '8px 14px', fontWeight: 'bold', fontFamily: 'monospace', wordBreak: 'break-word' }}>{routing}</td>
            </tr>
            <tr>
              <td style={{ padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Bank Name</td>
              <td style={{ padding: '8px 14px', fontWeight: 'bold', wordBreak: 'break-word' }}>{bankName}</td>
              <td style={{ padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Account Number</td>
              <td style={{ padding: '8px 14px', fontWeight: 'bold', fontFamily: 'monospace', wordBreak: 'break-word' }}>{fullAcct}</td>
            </tr>
            <tr style={{ borderTop: '1px solid #f1f5f9' }}>
              <td style={{ padding: '8px 14px', color: '#64748b', fontWeight: 'bold' }}>Name on Bank Details</td>
              <td colSpan={3} style={{ padding: '8px 14px', fontWeight: 'bold', wordBreak: 'break-word' }}>{holderName}</td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* 3. Electronic Signature & Compliance Audit Trail */}
      <div style={{ display: 'grid', gridTemplateColumns: '1.4fr 1fr', gap: '16px', marginTop: '20px' }}>
        {/* Signature */}
        <div style={{ border: '1px solid #cbd5e1', borderRadius: '4px', padding: '12px', backgroundColor: '#ffffff' }}>
          <div style={{ fontSize: '10px', fontWeight: 'bold', color: '#64748b', textTransform: 'uppercase', marginBottom: '8px' }}>
            Authorized Electronic Signature
          </div>
          <div style={{ height: '70px', border: '1px dashed #cbd5e1', borderRadius: '4px', backgroundColor: '#f8fafc', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', padding: '4px' }}>
            {signatureImage && signatureImage.startsWith('data:image') ? (
              <img src={signatureImage} alt="Applicant Signature" style={{ maxHeight: '62px', maxWidth: '100%', objectFit: 'contain' }} />
            ) : (
              <span style={{ fontFamily: 'cursive', fontSize: '20px', color: '#0f172a', fontWeight: 'bold' }}>
                {signatureImage || fullName}
              </span>
            )}
          </div>
          <div style={{ fontSize: '11px', fontWeight: 'bold', color: '#0f172a', marginTop: '6px' }}>
            Signer: {fullName}
          </div>
        </div>

        {/* Audit Trail */}
        <div style={{ border: '1px solid #cbd5e1', borderRadius: '4px', padding: '12px', backgroundColor: '#f8fafc', fontSize: '10.5px' }}>
          <div style={{ fontSize: '10px', fontWeight: 'bold', color: '#64748b', textTransform: 'uppercase', marginBottom: '8px' }}>
            Compliance Audit Trail
          </div>
          <div style={{ marginBottom: '5px' }}>
            <span style={{ color: '#64748b' }}>Reference ID:</span> <strong style={{ color: '#0f172a' }}>#{applicationRefId || 'LS-APP'}</strong>
          </div>
          <div style={{ marginBottom: '5px' }}>
            <span style={{ color: '#64748b' }}>Timestamp:</span> <strong style={{ color: '#0f172a' }}>{submissionDate || new Date().toLocaleString()}</strong>
          </div>
          <div style={{ marginBottom: '5px' }}>
            <span style={{ color: '#64748b' }}>IP Address:</span> <strong style={{ color: '#0f172a' }}>{ipAddress || '127.0.0.1'}</strong>
          </div>
          <div>
            <span style={{ color: '#64748b' }}>Verification:</span> <strong style={{ color: '#16a34a' }}>Completed Electronically ✓</strong>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={{ marginTop: '30px', borderTop: '1px solid #e2e8f0', paddingTop: '10px', textAlign: 'center', fontSize: '9.5px', color: '#94a3b8' }}>
        Insurance Enterprise USA • Official Application Record
      </div>
    </div>
  );
};

export default LumpSumApplicationDoc;
